module.exports = __webpack_public_path__ + "6d8fa3001dc33120d7c76dd1d221be91.svg";